import PieChartWithLegend from './pie-chart-with-legend';
export default PieChartWithLegend;
